module.exports = __webpack_public_path__ + "img/gjallarhorn_small.c37af71d.png";